import React, { Fragment, useRef, useEffect } from "react";
import { format } from "date-fns";
import "./message.scss";

const Message = (props) => {
  const messagesEndRef = useRef(null);
  const { message } = props;

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    document.title = "AliSouq";
  }, []);

  useEffect(() => {
    scrollToBottom();
  }, [props.disputeDetail]);

  return (
    <Fragment>
      <div className="meassage-desktop w-100" key={message.id}>
        {message?.owner?.toLowerCase() === "vendor" ? (
          <div className=" d-flex justify-content-end wrapper w-100 align-items-center">
            <div className="text-container d-flex align-items-center">
              <span
                className="text w-100 text-start"
                style={{
                  backgroundColor: "#c8dde8",
                }}
              >
                {message.description}
              </span>
              <span className="date w-100 text-start">
                {format(Date.parse(message.created_at), "MMM dd, yyy p")}
              </span>
            </div>
            <div
              className="name-container d-flex justify-content-center align-items-center"
              style={{
                backgroundColor: "#c8dde8",
                marginInlineStart: "10px",
              }}
            >
              V
            </div>
          </div>
        ) : (
          <div className=" d-flex justify-content-start wrapper w-100 align-items-center">
            <div
              className="name-container d-flex justify-content-center align-items-center"
              style={{
                backgroundColor: "#c8dde8",
                marginInlineEnd: "10px",
              }}
            >
              {message?.owner?.toLowerCase() === "admin" ? "A" : "C"}
            </div>
            <div className="text-container d-flex align-items-center">
              <span
                className="text w-100 text-start"
                style={{
                  backgroundColor: "#c8dde8",
                }}
              >
                {message.description}
              </span>
              <span className="date w-100 text-start">
                {format(Date.parse(message.created_at), "MMM dd, yyy p")}
              </span>
            </div>
          </div>
        )}
        <div ref={messagesEndRef}></div>
      </div>
    </Fragment>
  );
};

export default Message;
